import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import NewVendorsBanner from "./components/NewVendorsBanner";
import HeroSection from "./components/HeroSection";
import BookingTicker from "./components/BookingTicker";
import ServicesSection from "./components/ServicesSection";
import AppDownloadSection from "./components/AppDownloadSection";
import VendorSignup from "./components/VendorSignup";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FreeGyyfts from "./components/FreeGyyfts";
import BetaDownload from "./components/BetaDownload";
import AboutUs from "./components/AboutUs";
import Careers from "./components/Careers";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import AdminDashboard from "./components/AdminDashboard";
import Survey from "./components/Survey";
import VendorOnboarding from "./components/VendorOnboarding";
import YourHyyve from "./components/YourHyyve";
import MyCourses from "./components/MyCourses";
import Certifications from "./components/Certifications";
import SkillAssessments from "./components/SkillAssessments";
import Marketplace from "./components/Marketplace";
import MyOrders from "./components/MyOrders";
import FoundingVendorOffer from "./components/FoundingVendorOffer";
import ShareGyyfts from "./components/ShareGyyfts";
import BHyyve1000 from "./components/BHyyve1000";
import GiftAdmin from "./components/GiftAdmin";
import ClaimGift from "./components/ClaimGift";
import MeetingScheduler from "./components/MeetingScheduler";
import FoundingCustomerLanding from "./pages/FoundingCustomerLanding";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <NewVendorsBanner />
      <HeroSection />
      <ServicesSection />
      <AppDownloadSection />
      <VendorSignup />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/freegyyfts" element={<FreeGyyfts />} />
          <Route path="/appbeta100" element={<BetaDownload />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/vendoronboarding" element={<VendorOnboarding />} />
          <Route path="/foundingvendoroffer" element={<FoundingVendorOffer />} />
          <Route path="/yourhyyve" element={<YourHyyve />} />
          <Route path="/mycourses" element={<MyCourses />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/assessments" element={<SkillAssessments />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/myorders" element={<MyOrders />} />
          <Route path="/sharegyyfts" element={<ShareGyyfts />} />
          <Route path="/bHyyve1000" element={<BHyyve1000 />} />
          <Route path="/gift-admin" element={<GiftAdmin />} />
          <Route path="/claim-gift" element={<ClaimGift />} />
          <Route path="/meet" element={<MeetingScheduler />} />
          <Route path="/foundingcustomer" element={<FoundingCustomerLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
